import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Jumbo from "../components/Jumbo";
import ProductItem from "../components/ProductItem";

const pageName = "Products";
const message = "Products that will automate your business process.";

const ProductPage = () => {
  return (
    <div>
      <Jumbo pageName={pageName} message={message}></Jumbo>
      <ProductItem />
    </div>
  );
};

export default ProductPage;
